import { of } from "rxjs";
import { actionSceneSwap } from "./actionScenes";
export var pathSwapScene = function (scene) { return function (action, state$, deps) {
    return of(actionSceneSwap(scene.sceneId));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/pathSwapScene.ts
// module id = 2128
// module chunks = 3